import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StarBubbleIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "17",
    rx: "2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M5,18v3.5a.5.5,0,0,0,.85.35L9,18Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12.34,13.1l2.53,1.53a.25.25,0,0,0,.37-.26l-.67-2.89L16.8,9.55a.25.25,0,0,0-.14-.43l-2.95-.25L12.56,6.15a.24.24,0,0,0-.45,0L11,8.87,8,9.12a.25.25,0,0,0-.14.43l2.24,1.93-.67,2.89a.25.25,0,0,0,.37.26Z",
    fill: "#fff"
  })]
}), 'StarBubbleIcon');